import { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const formGroupRowStyleMixin = /*#__PURE__*/css(["padding:0;font-weight:initial;max-width:none;display:inline-flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:top;align-items:top;> *{margin-inline-end:", ";:last-child{margin-inline-end:", ";}}", ""], ({
  theme
}) => theme.spacing.xxsmall.default, ({
  inline,
  theme
}) => inline ? theme.spacing.xxxsmall.default : '0', isMobile(css(["margin-inline-end:0;:last-child{margin-inline-end:0;}"])));

export { formGroupRowStyleMixin as f };
//# sourceMappingURL=formGroupRowStyleMixin-DAlbntir.js.map
